module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "user-search-container"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input",
    attrs: {
      "type": "search",
      "name": "search",
      "placeholder": "search"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.loading && _vm.searchResults.length > 0) ? _c('ul', _vm._l((_vm.searchResults), function(user) {
    return _c('li', {
      staticClass: "flex-space-between panel-block"
    }, [_vm._v("\n        " + _vm._s(user.name || user.email) + " "), (user.is_coach) ? _c('span', {
      staticClass: "tag is-rounded is-primary"
    }, [_vm._v("Coach")]) : _vm._e(), (user.is_group_admin) ? _c('span', {
      staticClass: "tag is-rounded is-warning"
    }, [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), _c('input', {
      staticClass: "button is-small",
      attrs: {
        "type": "button",
        "value": "add",
        "name": "add"
      },
      on: {
        "click": function($event) {
          _vm.addUser(_vm.team.id, user)
        }
      }
    })])
  })) : (_vm.query !== '') ? _c('p', {
    staticClass: "no-results"
  }, [_vm._v("\n      No results for query "), _c('strong', [_vm._v(_vm._s(_vm.query))])]) : _c('p', {
    staticClass: "no-results"
  }, [_vm._v("No users to add.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-space-between user-search-title"
  }, [_c('h3', {
    staticClass: "title is-3"
  }, [_vm._v("Add Users")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-446bede0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupUserSearch.vue
// module id = 1018
// module chunks = 0